/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Clickhouse RDS API Specification
 * OpenAPI spec version: 0.0.7
 */
import { useMutation, useQuery } from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';

import { computed, unref } from 'vue';
import type { MaybeRef } from 'vue';

import type {
  ApiResponseActiveProcessRs,
  ApiResponseClickhouseParameterDetailRs,
  ApiResponseDiskInfoRs,
  ApiResponseMergeEventRs,
  ApiResponseMutationResponse,
  ApiResponseParameterResponse,
  ApiResponsePartActivityResponse,
  ApiResponsePartLogResponse,
  ApiResponseProcessKillRs,
  ApiResponseQueryLogRs,
  ApiResponseReplicationRs,
  ApiResponseSqlByIntervalRs,
  ApiResponseSqlHistoryRs,
  ApiResponseSqlInfoRs,
  ApiResponseSqlPlanRs,
  ApiResponseSqlTextRs,
  ApiResponseTextLogRs,
  GetV7ClickhouseActiveProcessByInstanceIdParams,
  GetV7ClickhouseParameterDetailByInstanceIdAndParameterNameParams,
  GetV7ClickhousePartLogByInstanceIdParams,
  GetV7ClickhouseQueryLogByInstanceIdParams,
  GetV7ClickhouseSqlByIntervalParams,
  GetV7ClickhouseSqlHistoryParams,
  GetV7ClickhouseSqlInfoParams,
  GetV7ClickhouseSqlTextByInstanceIdAndNormalizedQueryHashParams,
  GetV7ClickhouseTextLogByInstanceIdParams,
  GetV7ClickhouseTextLogScanMoreByInstanceIdParams,
  MultiProcessRq,
  SqlPlanRequest,
} from '../../model';

import { customAxiosInstance } from '../../../../common/api/utils/mutator';
import type { ErrorType, BodyType } from '../../../../common/api/utils/mutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary 데이터베이스 > 기본뷰 > 인스턴스 디테일 > 액티브 프로세스 탭 > 선택된 프로세스 멀티 킬
 */
export const postV7ClickhouseActiveProcessKillProcesses = (
  multiProcessRq: MaybeRef<MultiProcessRq[]>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  multiProcessRq = unref(multiProcessRq);

  return customAxiosInstance<ApiResponseProcessKillRs>(
    {
      url: `/api/v7/clickhouse/active-process/kill-processes`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: multiProcessRq,
      signal,
    },
    options,
  );
};

export const getPostV7ClickhouseActiveProcessKillProcessesMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV7ClickhouseActiveProcessKillProcesses>>,
    TError,
    { data: BodyType<MultiProcessRq[]> },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV7ClickhouseActiveProcessKillProcesses>>,
  TError,
  { data: BodyType<MultiProcessRq[]> },
  TContext
> => {
  const mutationKey = ['postV7ClickhouseActiveProcessKillProcesses'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV7ClickhouseActiveProcessKillProcesses>>,
    { data: BodyType<MultiProcessRq[]> }
  > = (props) => {
    const { data } = props ?? {};

    return postV7ClickhouseActiveProcessKillProcesses(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV7ClickhouseActiveProcessKillProcessesMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV7ClickhouseActiveProcessKillProcesses>>
>;
export type PostV7ClickhouseActiveProcessKillProcessesMutationBody = BodyType<MultiProcessRq[]>;
export type PostV7ClickhouseActiveProcessKillProcessesMutationError = ErrorType<unknown>;

/**
 * @summary 데이터베이스 > 기본뷰 > 인스턴스 디테일 > 액티브 프로세스 탭 > 선택된 프로세스 멀티 킬
 */
export const usePostV7ClickhouseActiveProcessKillProcesses = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV7ClickhouseActiveProcessKillProcesses>>,
      TError,
      { data: BodyType<MultiProcessRq[]> },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postV7ClickhouseActiveProcessKillProcesses>>,
  TError,
  { data: BodyType<MultiProcessRq[]> },
  TContext
> => {
  const mutationOptions = getPostV7ClickhouseActiveProcessKillProcessesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 액티브 프로세스는 now - 1분 이내 가장 최근 시간으로 조회합니다.
 * @summary 데이터베이스 > 기본뷰 > 인스턴스 디테일 > 액티브 프로세스 탭
 */
export const getV7ClickhouseActiveProcessByInstanceId = (
  instanceId: MaybeRef<string>,
  params?: MaybeRef<GetV7ClickhouseActiveProcessByInstanceIdParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  instanceId = unref(instanceId);
  params = unref(params);

  return customAxiosInstance<ApiResponseActiveProcessRs>(
    {
      url: `/api/v7/clickhouse/active-process/${instanceId}`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getGetV7ClickhouseActiveProcessByInstanceIdQueryKey = (
  instanceId?: MaybeRef<string>,
  params?: MaybeRef<GetV7ClickhouseActiveProcessByInstanceIdParams>,
) => {
  return [
    'api',
    'v7',
    'clickhouse',
    'active-process',
    instanceId,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV7ClickhouseActiveProcessByInstanceIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7ClickhouseActiveProcessByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  params?: MaybeRef<GetV7ClickhouseActiveProcessByInstanceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7ClickhouseActiveProcessByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7ClickhouseActiveProcessByInstanceIdQueryKey(instanceId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV7ClickhouseActiveProcessByInstanceId>>
  > = ({ signal }) =>
    getV7ClickhouseActiveProcessByInstanceId(instanceId, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(instanceId)),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7ClickhouseActiveProcessByInstanceId>>,
    TError,
    TData
  >;
};

export type GetV7ClickhouseActiveProcessByInstanceIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7ClickhouseActiveProcessByInstanceId>>
>;
export type GetV7ClickhouseActiveProcessByInstanceIdQueryError = ErrorType<unknown>;

/**
 * @summary 데이터베이스 > 기본뷰 > 인스턴스 디테일 > 액티브 프로세스 탭
 */

export function useGetV7ClickhouseActiveProcessByInstanceId<
  TData = Awaited<ReturnType<typeof getV7ClickhouseActiveProcessByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  params?: MaybeRef<GetV7ClickhouseActiveProcessByInstanceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7ClickhouseActiveProcessByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7ClickhouseActiveProcessByInstanceIdQueryOptions(
    instanceId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary 데이터베이스 > 기본뷰 > 인스턴스 디테일 > 정보 탭 > 디스크 정보
 */
export const getV7ClickhouseDiskInfoByInstanceId = (
  instanceId: MaybeRef<string>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  instanceId = unref(instanceId);

  return customAxiosInstance<ApiResponseDiskInfoRs>(
    { url: `/api/v7/clickhouse/disk-info/${instanceId}`, method: 'GET', signal },
    options,
  );
};

export const getGetV7ClickhouseDiskInfoByInstanceIdQueryKey = (instanceId?: MaybeRef<string>) => {
  return ['api', 'v7', 'clickhouse', 'disk-info', instanceId] as const;
};

export const getGetV7ClickhouseDiskInfoByInstanceIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7ClickhouseDiskInfoByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7ClickhouseDiskInfoByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7ClickhouseDiskInfoByInstanceIdQueryKey(instanceId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7ClickhouseDiskInfoByInstanceId>>> = ({
    signal,
  }) => getV7ClickhouseDiskInfoByInstanceId(instanceId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(instanceId)),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7ClickhouseDiskInfoByInstanceId>>,
    TError,
    TData
  >;
};

export type GetV7ClickhouseDiskInfoByInstanceIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7ClickhouseDiskInfoByInstanceId>>
>;
export type GetV7ClickhouseDiskInfoByInstanceIdQueryError = ErrorType<unknown>;

/**
 * @summary 데이터베이스 > 기본뷰 > 인스턴스 디테일 > 정보 탭 > 디스크 정보
 */

export function useGetV7ClickhouseDiskInfoByInstanceId<
  TData = Awaited<ReturnType<typeof getV7ClickhouseDiskInfoByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7ClickhouseDiskInfoByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7ClickhouseDiskInfoByInstanceIdQueryOptions(instanceId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary 데이터베이스 > 기본뷰 > 인스턴스 디테일 > 병합 이벤트 탭
 */
export const getV7ClickhouseMergeEventByInstanceId = (
  instanceId: MaybeRef<string>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  instanceId = unref(instanceId);

  return customAxiosInstance<ApiResponseMergeEventRs>(
    { url: `/api/v7/clickhouse/merge-event/${instanceId}`, method: 'GET', signal },
    options,
  );
};

export const getGetV7ClickhouseMergeEventByInstanceIdQueryKey = (instanceId?: MaybeRef<string>) => {
  return ['api', 'v7', 'clickhouse', 'merge-event', instanceId] as const;
};

export const getGetV7ClickhouseMergeEventByInstanceIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7ClickhouseMergeEventByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7ClickhouseMergeEventByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7ClickhouseMergeEventByInstanceIdQueryKey(instanceId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV7ClickhouseMergeEventByInstanceId>>
  > = ({ signal }) => getV7ClickhouseMergeEventByInstanceId(instanceId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(instanceId)),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7ClickhouseMergeEventByInstanceId>>,
    TError,
    TData
  >;
};

export type GetV7ClickhouseMergeEventByInstanceIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7ClickhouseMergeEventByInstanceId>>
>;
export type GetV7ClickhouseMergeEventByInstanceIdQueryError = ErrorType<unknown>;

/**
 * @summary 데이터베이스 > 기본뷰 > 인스턴스 디테일 > 병합 이벤트 탭
 */

export function useGetV7ClickhouseMergeEventByInstanceId<
  TData = Awaited<ReturnType<typeof getV7ClickhouseMergeEventByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7ClickhouseMergeEventByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7ClickhouseMergeEventByInstanceIdQueryOptions(instanceId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary 데이터베이스 > 기본뷰 > 인스턴스 디테일 > 뮤테이션 탭
 */
export const getV7ClickhouseMutationByInstanceId = (
  instanceId: MaybeRef<string>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  instanceId = unref(instanceId);

  return customAxiosInstance<ApiResponseMutationResponse>(
    { url: `/api/v7/clickhouse/mutation/${instanceId}`, method: 'GET', signal },
    options,
  );
};

export const getGetV7ClickhouseMutationByInstanceIdQueryKey = (instanceId?: MaybeRef<string>) => {
  return ['api', 'v7', 'clickhouse', 'mutation', instanceId] as const;
};

export const getGetV7ClickhouseMutationByInstanceIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7ClickhouseMutationByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7ClickhouseMutationByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7ClickhouseMutationByInstanceIdQueryKey(instanceId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7ClickhouseMutationByInstanceId>>> = ({
    signal,
  }) => getV7ClickhouseMutationByInstanceId(instanceId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(instanceId)),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7ClickhouseMutationByInstanceId>>,
    TError,
    TData
  >;
};

export type GetV7ClickhouseMutationByInstanceIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7ClickhouseMutationByInstanceId>>
>;
export type GetV7ClickhouseMutationByInstanceIdQueryError = ErrorType<unknown>;

/**
 * @summary 데이터베이스 > 기본뷰 > 인스턴스 디테일 > 뮤테이션 탭
 */

export function useGetV7ClickhouseMutationByInstanceId<
  TData = Awaited<ReturnType<typeof getV7ClickhouseMutationByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7ClickhouseMutationByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7ClickhouseMutationByInstanceIdQueryOptions(instanceId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary 데이터베이스 > 기본뷰 > 인스턴스 디테일 > 파라미터 탭
 */
export const getV7ClickhouseParameterByInstanceId = (
  instanceId: MaybeRef<string>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  instanceId = unref(instanceId);

  return customAxiosInstance<ApiResponseParameterResponse>(
    { url: `/api/v7/clickhouse/parameter/${instanceId}`, method: 'GET', signal },
    options,
  );
};

export const getGetV7ClickhouseParameterByInstanceIdQueryKey = (instanceId?: MaybeRef<string>) => {
  return ['api', 'v7', 'clickhouse', 'parameter', instanceId] as const;
};

export const getGetV7ClickhouseParameterByInstanceIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7ClickhouseParameterByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7ClickhouseParameterByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7ClickhouseParameterByInstanceIdQueryKey(instanceId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV7ClickhouseParameterByInstanceId>>
  > = ({ signal }) => getV7ClickhouseParameterByInstanceId(instanceId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(instanceId)),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7ClickhouseParameterByInstanceId>>,
    TError,
    TData
  >;
};

export type GetV7ClickhouseParameterByInstanceIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7ClickhouseParameterByInstanceId>>
>;
export type GetV7ClickhouseParameterByInstanceIdQueryError = ErrorType<unknown>;

/**
 * @summary 데이터베이스 > 기본뷰 > 인스턴스 디테일 > 파라미터 탭
 */

export function useGetV7ClickhouseParameterByInstanceId<
  TData = Awaited<ReturnType<typeof getV7ClickhouseParameterByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7ClickhouseParameterByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7ClickhouseParameterByInstanceIdQueryOptions(instanceId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary 데이터베이스 > 기본뷰 > 인스턴스 디테일 > 파트 현황 탭
 */
export const getV7ClickhousePartActivityByInstanceId = (
  instanceId: MaybeRef<string>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  instanceId = unref(instanceId);

  return customAxiosInstance<ApiResponsePartActivityResponse>(
    { url: `/api/v7/clickhouse/part-activity/${instanceId}`, method: 'GET', signal },
    options,
  );
};

export const getGetV7ClickhousePartActivityByInstanceIdQueryKey = (
  instanceId?: MaybeRef<string>,
) => {
  return ['api', 'v7', 'clickhouse', 'part-activity', instanceId] as const;
};

export const getGetV7ClickhousePartActivityByInstanceIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7ClickhousePartActivityByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7ClickhousePartActivityByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7ClickhousePartActivityByInstanceIdQueryKey(instanceId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV7ClickhousePartActivityByInstanceId>>
  > = ({ signal }) => getV7ClickhousePartActivityByInstanceId(instanceId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(instanceId)),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7ClickhousePartActivityByInstanceId>>,
    TError,
    TData
  >;
};

export type GetV7ClickhousePartActivityByInstanceIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7ClickhousePartActivityByInstanceId>>
>;
export type GetV7ClickhousePartActivityByInstanceIdQueryError = ErrorType<unknown>;

/**
 * @summary 데이터베이스 > 기본뷰 > 인스턴스 디테일 > 파트 현황 탭
 */

export function useGetV7ClickhousePartActivityByInstanceId<
  TData = Awaited<ReturnType<typeof getV7ClickhousePartActivityByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7ClickhousePartActivityByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7ClickhousePartActivityByInstanceIdQueryOptions(instanceId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary 데이터베이스 > 기본뷰 > 인스턴스 디테일 > 파트 로그 탭
 */
export const getV7ClickhousePartLogByInstanceId = (
  instanceId: MaybeRef<string>,
  params?: MaybeRef<GetV7ClickhousePartLogByInstanceIdParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  instanceId = unref(instanceId);
  params = unref(params);

  return customAxiosInstance<ApiResponsePartLogResponse>(
    {
      url: `/api/v7/clickhouse/part-log/${instanceId}`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getGetV7ClickhousePartLogByInstanceIdQueryKey = (
  instanceId?: MaybeRef<string>,
  params?: MaybeRef<GetV7ClickhousePartLogByInstanceIdParams>,
) => {
  return ['api', 'v7', 'clickhouse', 'part-log', instanceId, ...(params ? [params] : [])] as const;
};

export const getGetV7ClickhousePartLogByInstanceIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7ClickhousePartLogByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  params?: MaybeRef<GetV7ClickhousePartLogByInstanceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7ClickhousePartLogByInstanceId>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7ClickhousePartLogByInstanceIdQueryKey(instanceId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7ClickhousePartLogByInstanceId>>> = ({
    signal,
  }) => getV7ClickhousePartLogByInstanceId(instanceId, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(instanceId)),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7ClickhousePartLogByInstanceId>>,
    TError,
    TData
  >;
};

export type GetV7ClickhousePartLogByInstanceIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7ClickhousePartLogByInstanceId>>
>;
export type GetV7ClickhousePartLogByInstanceIdQueryError = ErrorType<unknown>;

/**
 * @summary 데이터베이스 > 기본뷰 > 인스턴스 디테일 > 파트 로그 탭
 */

export function useGetV7ClickhousePartLogByInstanceId<
  TData = Awaited<ReturnType<typeof getV7ClickhousePartLogByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  params?: MaybeRef<GetV7ClickhousePartLogByInstanceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7ClickhousePartLogByInstanceId>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7ClickhousePartLogByInstanceIdQueryOptions(
    instanceId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary 데이터베이스 > 기본뷰 > 인스턴스 디테일 > 쿼리 로그 탭
 */
export const getV7ClickhouseQueryLogByInstanceId = (
  instanceId: MaybeRef<string>,
  params?: MaybeRef<GetV7ClickhouseQueryLogByInstanceIdParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  instanceId = unref(instanceId);
  params = unref(params);

  return customAxiosInstance<ApiResponseQueryLogRs>(
    {
      url: `/api/v7/clickhouse/query-log/${instanceId}`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getGetV7ClickhouseQueryLogByInstanceIdQueryKey = (
  instanceId?: MaybeRef<string>,
  params?: MaybeRef<GetV7ClickhouseQueryLogByInstanceIdParams>,
) => {
  return ['api', 'v7', 'clickhouse', 'query-log', instanceId, ...(params ? [params] : [])] as const;
};

export const getGetV7ClickhouseQueryLogByInstanceIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7ClickhouseQueryLogByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  params?: MaybeRef<GetV7ClickhouseQueryLogByInstanceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7ClickhouseQueryLogByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7ClickhouseQueryLogByInstanceIdQueryKey(instanceId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7ClickhouseQueryLogByInstanceId>>> = ({
    signal,
  }) => getV7ClickhouseQueryLogByInstanceId(instanceId, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(instanceId)),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7ClickhouseQueryLogByInstanceId>>,
    TError,
    TData
  >;
};

export type GetV7ClickhouseQueryLogByInstanceIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7ClickhouseQueryLogByInstanceId>>
>;
export type GetV7ClickhouseQueryLogByInstanceIdQueryError = ErrorType<unknown>;

/**
 * @summary 데이터베이스 > 기본뷰 > 인스턴스 디테일 > 쿼리 로그 탭
 */

export function useGetV7ClickhouseQueryLogByInstanceId<
  TData = Awaited<ReturnType<typeof getV7ClickhouseQueryLogByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  params?: MaybeRef<GetV7ClickhouseQueryLogByInstanceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7ClickhouseQueryLogByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7ClickhouseQueryLogByInstanceIdQueryOptions(
    instanceId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary 데이터베이스 > 기본뷰 > 인스턴스 디테일 > 복제 상태 탭
 */
export const getV7ClickhouseReplicationByInstanceId = (
  instanceId: MaybeRef<string>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  instanceId = unref(instanceId);

  return customAxiosInstance<ApiResponseReplicationRs>(
    { url: `/api/v7/clickhouse/replication/${instanceId}`, method: 'GET', signal },
    options,
  );
};

export const getGetV7ClickhouseReplicationByInstanceIdQueryKey = (
  instanceId?: MaybeRef<string>,
) => {
  return ['api', 'v7', 'clickhouse', 'replication', instanceId] as const;
};

export const getGetV7ClickhouseReplicationByInstanceIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7ClickhouseReplicationByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7ClickhouseReplicationByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7ClickhouseReplicationByInstanceIdQueryKey(instanceId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV7ClickhouseReplicationByInstanceId>>
  > = ({ signal }) => getV7ClickhouseReplicationByInstanceId(instanceId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(instanceId)),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7ClickhouseReplicationByInstanceId>>,
    TError,
    TData
  >;
};

export type GetV7ClickhouseReplicationByInstanceIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7ClickhouseReplicationByInstanceId>>
>;
export type GetV7ClickhouseReplicationByInstanceIdQueryError = ErrorType<unknown>;

/**
 * @summary 데이터베이스 > 기본뷰 > 인스턴스 디테일 > 복제 상태 탭
 */

export function useGetV7ClickhouseReplicationByInstanceId<
  TData = Awaited<ReturnType<typeof getV7ClickhouseReplicationByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7ClickhouseReplicationByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7ClickhouseReplicationByInstanceIdQueryOptions(instanceId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary SQL 디테일 화면 > 추이 탭
 */
export const getV7ClickhouseSqlByInterval = (
  params: MaybeRef<GetV7ClickhouseSqlByIntervalParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<ApiResponseSqlByIntervalRs>(
    { url: `/api/v7/clickhouse/sql-by-interval`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV7ClickhouseSqlByIntervalQueryKey = (
  params?: MaybeRef<GetV7ClickhouseSqlByIntervalParams>,
) => {
  return ['api', 'v7', 'clickhouse', 'sql-by-interval', ...(params ? [params] : [])] as const;
};

export const getGetV7ClickhouseSqlByIntervalQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7ClickhouseSqlByInterval>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7ClickhouseSqlByIntervalParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7ClickhouseSqlByInterval>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7ClickhouseSqlByIntervalQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7ClickhouseSqlByInterval>>> = ({
    signal,
  }) => getV7ClickhouseSqlByInterval(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7ClickhouseSqlByInterval>>,
    TError,
    TData
  >;
};

export type GetV7ClickhouseSqlByIntervalQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7ClickhouseSqlByInterval>>
>;
export type GetV7ClickhouseSqlByIntervalQueryError = ErrorType<unknown>;

/**
 * @summary SQL 디테일 화면 > 추이 탭
 */

export function useGetV7ClickhouseSqlByInterval<
  TData = Awaited<ReturnType<typeof getV7ClickhouseSqlByInterval>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7ClickhouseSqlByIntervalParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7ClickhouseSqlByInterval>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7ClickhouseSqlByIntervalQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary SQL 디테일 화면 > 과거이력 탭
 */
export const getV7ClickhouseSqlHistory = (
  params: MaybeRef<GetV7ClickhouseSqlHistoryParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<ApiResponseSqlHistoryRs>(
    { url: `/api/v7/clickhouse/sql-history`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV7ClickhouseSqlHistoryQueryKey = (
  params?: MaybeRef<GetV7ClickhouseSqlHistoryParams>,
) => {
  return ['api', 'v7', 'clickhouse', 'sql-history', ...(params ? [params] : [])] as const;
};

export const getGetV7ClickhouseSqlHistoryQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7ClickhouseSqlHistory>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7ClickhouseSqlHistoryParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7ClickhouseSqlHistory>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7ClickhouseSqlHistoryQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7ClickhouseSqlHistory>>> = ({
    signal,
  }) => getV7ClickhouseSqlHistory(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7ClickhouseSqlHistory>>,
    TError,
    TData
  >;
};

export type GetV7ClickhouseSqlHistoryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7ClickhouseSqlHistory>>
>;
export type GetV7ClickhouseSqlHistoryQueryError = ErrorType<unknown>;

/**
 * @summary SQL 디테일 화면 > 과거이력 탭
 */

export function useGetV7ClickhouseSqlHistory<
  TData = Awaited<ReturnType<typeof getV7ClickhouseSqlHistory>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7ClickhouseSqlHistoryParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7ClickhouseSqlHistory>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7ClickhouseSqlHistoryQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * 파라미터로 넘어온 값 그대로 리턴된다.
 * @summary 인스턴스 디테일 > 상단 기본 정보
 */
export const getV7ClickhouseSqlInfo = (
  params: MaybeRef<GetV7ClickhouseSqlInfoParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<ApiResponseSqlInfoRs>(
    { url: `/api/v7/clickhouse/sql-info`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getGetV7ClickhouseSqlInfoQueryKey = (
  params?: MaybeRef<GetV7ClickhouseSqlInfoParams>,
) => {
  return ['api', 'v7', 'clickhouse', 'sql-info', ...(params ? [params] : [])] as const;
};

export const getGetV7ClickhouseSqlInfoQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7ClickhouseSqlInfo>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7ClickhouseSqlInfoParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7ClickhouseSqlInfo>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7ClickhouseSqlInfoQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7ClickhouseSqlInfo>>> = ({ signal }) =>
    getV7ClickhouseSqlInfo(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7ClickhouseSqlInfo>>,
    TError,
    TData
  >;
};

export type GetV7ClickhouseSqlInfoQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7ClickhouseSqlInfo>>
>;
export type GetV7ClickhouseSqlInfoQueryError = ErrorType<unknown>;

/**
 * @summary 인스턴스 디테일 > 상단 기본 정보
 */

export function useGetV7ClickhouseSqlInfo<
  TData = Awaited<ReturnType<typeof getV7ClickhouseSqlInfo>>,
  TError = ErrorType<unknown>,
>(
  params: MaybeRef<GetV7ClickhouseSqlInfoParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7ClickhouseSqlInfo>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7ClickhouseSqlInfoQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary SQL 디테일 화면 > Plan 탭
 */
export const postV7ClickhouseSqlPlanByInstanceId = (
  instanceId: MaybeRef<string>,
  sqlPlanRequest: MaybeRef<SqlPlanRequest>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  instanceId = unref(instanceId);
  sqlPlanRequest = unref(sqlPlanRequest);

  return customAxiosInstance<ApiResponseSqlPlanRs>(
    {
      url: `/api/v7/clickhouse/sql-plan/${instanceId}`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: sqlPlanRequest,
      signal,
    },
    options,
  );
};

export const getPostV7ClickhouseSqlPlanByInstanceIdMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV7ClickhouseSqlPlanByInstanceId>>,
    TError,
    { instanceId: string; data: BodyType<SqlPlanRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV7ClickhouseSqlPlanByInstanceId>>,
  TError,
  { instanceId: string; data: BodyType<SqlPlanRequest> },
  TContext
> => {
  const mutationKey = ['postV7ClickhouseSqlPlanByInstanceId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV7ClickhouseSqlPlanByInstanceId>>,
    { instanceId: string; data: BodyType<SqlPlanRequest> }
  > = (props) => {
    const { instanceId, data } = props ?? {};

    return postV7ClickhouseSqlPlanByInstanceId(instanceId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV7ClickhouseSqlPlanByInstanceIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV7ClickhouseSqlPlanByInstanceId>>
>;
export type PostV7ClickhouseSqlPlanByInstanceIdMutationBody = BodyType<SqlPlanRequest>;
export type PostV7ClickhouseSqlPlanByInstanceIdMutationError = ErrorType<unknown>;

/**
 * @summary SQL 디테일 화면 > Plan 탭
 */
export const usePostV7ClickhouseSqlPlanByInstanceId = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV7ClickhouseSqlPlanByInstanceId>>,
      TError,
      { instanceId: string; data: BodyType<SqlPlanRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postV7ClickhouseSqlPlanByInstanceId>>,
  TError,
  { instanceId: string; data: BodyType<SqlPlanRequest> },
  TContext
> => {
  const mutationOptions = getPostV7ClickhouseSqlPlanByInstanceIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * redis 실시간 조회 기능
 * @summary 데이터베이스 > 기본뷰 > 인스턴스 디테일 > 텍스트 로그 탭
 */
export const getV7ClickhouseTextLogByInstanceId = (
  instanceId: MaybeRef<string>,
  params?: MaybeRef<GetV7ClickhouseTextLogByInstanceIdParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  instanceId = unref(instanceId);
  params = unref(params);

  return customAxiosInstance<ApiResponseTextLogRs>(
    {
      url: `/api/v7/clickhouse/text-log/${instanceId}`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getGetV7ClickhouseTextLogByInstanceIdQueryKey = (
  instanceId?: MaybeRef<string>,
  params?: MaybeRef<GetV7ClickhouseTextLogByInstanceIdParams>,
) => {
  return ['api', 'v7', 'clickhouse', 'text-log', instanceId, ...(params ? [params] : [])] as const;
};

export const getGetV7ClickhouseTextLogByInstanceIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7ClickhouseTextLogByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  params?: MaybeRef<GetV7ClickhouseTextLogByInstanceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7ClickhouseTextLogByInstanceId>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7ClickhouseTextLogByInstanceIdQueryKey(instanceId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7ClickhouseTextLogByInstanceId>>> = ({
    signal,
  }) => getV7ClickhouseTextLogByInstanceId(instanceId, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(instanceId)),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7ClickhouseTextLogByInstanceId>>,
    TError,
    TData
  >;
};

export type GetV7ClickhouseTextLogByInstanceIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7ClickhouseTextLogByInstanceId>>
>;
export type GetV7ClickhouseTextLogByInstanceIdQueryError = ErrorType<unknown>;

/**
 * @summary 데이터베이스 > 기본뷰 > 인스턴스 디테일 > 텍스트 로그 탭
 */

export function useGetV7ClickhouseTextLogByInstanceId<
  TData = Awaited<ReturnType<typeof getV7ClickhouseTextLogByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  params?: MaybeRef<GetV7ClickhouseTextLogByInstanceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV7ClickhouseTextLogByInstanceId>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7ClickhouseTextLogByInstanceIdQueryOptions(
    instanceId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * redis 실시간 조회 기능
 * @summary 데이터베이스 > 기본뷰 > 인스턴스 디테일 > 텍스트 로그 탭 > 더보기 버튼 전용
 */
export const getV7ClickhouseTextLogScanMoreByInstanceId = (
  instanceId: MaybeRef<string>,
  params: MaybeRef<GetV7ClickhouseTextLogScanMoreByInstanceIdParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  instanceId = unref(instanceId);
  params = unref(params);

  return customAxiosInstance<ApiResponseTextLogRs>(
    {
      url: `/api/v7/clickhouse/text-log/${instanceId}/scan-more`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getGetV7ClickhouseTextLogScanMoreByInstanceIdQueryKey = (
  instanceId?: MaybeRef<string>,
  params?: MaybeRef<GetV7ClickhouseTextLogScanMoreByInstanceIdParams>,
) => {
  return [
    'api',
    'v7',
    'clickhouse',
    'text-log',
    instanceId,
    'scan-more',
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV7ClickhouseTextLogScanMoreByInstanceIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7ClickhouseTextLogScanMoreByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  params: MaybeRef<GetV7ClickhouseTextLogScanMoreByInstanceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7ClickhouseTextLogScanMoreByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7ClickhouseTextLogScanMoreByInstanceIdQueryKey(instanceId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV7ClickhouseTextLogScanMoreByInstanceId>>
  > = ({ signal }) =>
    getV7ClickhouseTextLogScanMoreByInstanceId(instanceId, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(instanceId)),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7ClickhouseTextLogScanMoreByInstanceId>>,
    TError,
    TData
  >;
};

export type GetV7ClickhouseTextLogScanMoreByInstanceIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7ClickhouseTextLogScanMoreByInstanceId>>
>;
export type GetV7ClickhouseTextLogScanMoreByInstanceIdQueryError = ErrorType<unknown>;

/**
 * @summary 데이터베이스 > 기본뷰 > 인스턴스 디테일 > 텍스트 로그 탭 > 더보기 버튼 전용
 */

export function useGetV7ClickhouseTextLogScanMoreByInstanceId<
  TData = Awaited<ReturnType<typeof getV7ClickhouseTextLogScanMoreByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  params: MaybeRef<GetV7ClickhouseTextLogScanMoreByInstanceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7ClickhouseTextLogScanMoreByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7ClickhouseTextLogScanMoreByInstanceIdQueryOptions(
    instanceId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary ClickHouse - 파라미터 디테일 (Information과 History 분리)
 */
export const getV7ClickhouseParameterDetailByInstanceIdAndParameterName = (
  instanceId: MaybeRef<string>,
  parameterName: MaybeRef<string>,
  params: MaybeRef<GetV7ClickhouseParameterDetailByInstanceIdAndParameterNameParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  instanceId = unref(instanceId);
  parameterName = unref(parameterName);
  params = unref(params);

  return customAxiosInstance<ApiResponseClickhouseParameterDetailRs>(
    {
      url: `/api/v7/clickhouse/${instanceId}/parameter/${parameterName}/detail`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getGetV7ClickhouseParameterDetailByInstanceIdAndParameterNameQueryKey = (
  instanceId?: MaybeRef<string>,
  parameterName?: MaybeRef<string>,
  params?: MaybeRef<GetV7ClickhouseParameterDetailByInstanceIdAndParameterNameParams>,
) => {
  return [
    'api',
    'v7',
    'clickhouse',
    instanceId,
    'parameter',
    parameterName,
    'detail',
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV7ClickhouseParameterDetailByInstanceIdAndParameterNameQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7ClickhouseParameterDetailByInstanceIdAndParameterName>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  parameterName: MaybeRef<string>,
  params: MaybeRef<GetV7ClickhouseParameterDetailByInstanceIdAndParameterNameParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7ClickhouseParameterDetailByInstanceIdAndParameterName>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7ClickhouseParameterDetailByInstanceIdAndParameterNameQueryKey(
    instanceId,
    parameterName,
    params,
  );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV7ClickhouseParameterDetailByInstanceIdAndParameterName>>
  > = ({ signal }) =>
    getV7ClickhouseParameterDetailByInstanceIdAndParameterName(
      instanceId,
      parameterName,
      params,
      requestOptions,
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!(unref(instanceId) && unref(parameterName))),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7ClickhouseParameterDetailByInstanceIdAndParameterName>>,
    TError,
    TData
  >;
};

export type GetV7ClickhouseParameterDetailByInstanceIdAndParameterNameQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7ClickhouseParameterDetailByInstanceIdAndParameterName>>
>;
export type GetV7ClickhouseParameterDetailByInstanceIdAndParameterNameQueryError =
  ErrorType<unknown>;

/**
 * @summary ClickHouse - 파라미터 디테일 (Information과 History 분리)
 */

export function useGetV7ClickhouseParameterDetailByInstanceIdAndParameterName<
  TData = Awaited<ReturnType<typeof getV7ClickhouseParameterDetailByInstanceIdAndParameterName>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  parameterName: MaybeRef<string>,
  params: MaybeRef<GetV7ClickhouseParameterDetailByInstanceIdAndParameterNameParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7ClickhouseParameterDetailByInstanceIdAndParameterName>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7ClickhouseParameterDetailByInstanceIdAndParameterNameQueryOptions(
    instanceId,
    parameterName,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary SQL 의 fullText 를 조회하는 API
 */
export const getV7ClickhouseSqlTextByInstanceIdAndNormalizedQueryHash = (
  instanceId: MaybeRef<string>,
  normalizedQueryHash: MaybeRef<string>,
  params?: MaybeRef<GetV7ClickhouseSqlTextByInstanceIdAndNormalizedQueryHashParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  instanceId = unref(instanceId);
  normalizedQueryHash = unref(normalizedQueryHash);
  params = unref(params);

  return customAxiosInstance<ApiResponseSqlTextRs>(
    {
      url: `/api/v7/clickhouse/${instanceId}/sql-text/${normalizedQueryHash}`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getGetV7ClickhouseSqlTextByInstanceIdAndNormalizedQueryHashQueryKey = (
  instanceId?: MaybeRef<string>,
  normalizedQueryHash?: MaybeRef<string>,
  params?: MaybeRef<GetV7ClickhouseSqlTextByInstanceIdAndNormalizedQueryHashParams>,
) => {
  return [
    'api',
    'v7',
    'clickhouse',
    instanceId,
    'sql-text',
    normalizedQueryHash,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV7ClickhouseSqlTextByInstanceIdAndNormalizedQueryHashQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7ClickhouseSqlTextByInstanceIdAndNormalizedQueryHash>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  normalizedQueryHash: MaybeRef<string>,
  params?: MaybeRef<GetV7ClickhouseSqlTextByInstanceIdAndNormalizedQueryHashParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7ClickhouseSqlTextByInstanceIdAndNormalizedQueryHash>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7ClickhouseSqlTextByInstanceIdAndNormalizedQueryHashQueryKey(
    instanceId,
    normalizedQueryHash,
    params,
  );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV7ClickhouseSqlTextByInstanceIdAndNormalizedQueryHash>>
  > = ({ signal }) =>
    getV7ClickhouseSqlTextByInstanceIdAndNormalizedQueryHash(
      instanceId,
      normalizedQueryHash,
      params,
      requestOptions,
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!(unref(instanceId) && unref(normalizedQueryHash))),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7ClickhouseSqlTextByInstanceIdAndNormalizedQueryHash>>,
    TError,
    TData
  >;
};

export type GetV7ClickhouseSqlTextByInstanceIdAndNormalizedQueryHashQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7ClickhouseSqlTextByInstanceIdAndNormalizedQueryHash>>
>;
export type GetV7ClickhouseSqlTextByInstanceIdAndNormalizedQueryHashQueryError = ErrorType<unknown>;

/**
 * @summary SQL 의 fullText 를 조회하는 API
 */

export function useGetV7ClickhouseSqlTextByInstanceIdAndNormalizedQueryHash<
  TData = Awaited<ReturnType<typeof getV7ClickhouseSqlTextByInstanceIdAndNormalizedQueryHash>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  normalizedQueryHash: MaybeRef<string>,
  params?: MaybeRef<GetV7ClickhouseSqlTextByInstanceIdAndNormalizedQueryHashParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7ClickhouseSqlTextByInstanceIdAndNormalizedQueryHash>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7ClickhouseSqlTextByInstanceIdAndNormalizedQueryHashQueryOptions(
    instanceId,
    normalizedQueryHash,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}
